import { useEffect } from 'react';
import { fetchUserProfile } from '../services/profileService';
import { getUserId } from '../utils/profileFormat';

/**
 * Keeps the logged-in user's picture (shown in the top bar and side bar) up to date: once after
 * login or a page reload it reads the profile (GET /rfp/auth/users/{user_id}) and passes the
 * picture on. If that fails, whatever picture is already known stays.
 *
 * @param {object|null} user  the logged-in user
 * @param {boolean} isLoggedIn
 * @param {(patch: { avatar_url: string }) => void} onUserUpdate  must be stable (e.g. useCallback)
 */
export const useAccountAvatarSync = (user, isLoggedIn, onUserUpdate) => {
    const userId = getUserId(user);

    useEffect(() => {
        if (!isLoggedIn || !userId) return undefined;

        let cancelled = false;
        fetchUserProfile(userId)
            .then((response) => {
                if (cancelled) return;
                onUserUpdate({ avatar_url: response?.data?.avatar_url || '' });
            })
            .catch(() => {
                // Not critical: the initials (or the last known picture) stay.
            });

        return () => {
            cancelled = true;
        };
    }, [isLoggedIn, userId, onUserUpdate]);
};
